import { AddressValidationInput } from '@minecraft.graphql-operations';
import { PaymentMethodFormType } from '../Checkout/types';

export type BillingAddressFields = Pick<
  PaymentMethodFormType,
  'address_line_1' | 'address_line_2' | 'city' | 'state_region' | 'postal_code' | 'country'
>;

// Current Formik-shaped values -> GraphQL input.
export const toAddressValidationInput = (fields: BillingAddressFields): AddressValidationInput => ({
  regionCode: fields.country,
  // Required by Google's API and always sent, but per AC6.2 these never drive the verdict — only
  // regionCode/locality/administrativeArea/postalCode do.
  addressLines: [fields.address_line_1, fields.address_line_2].filter(Boolean),
  locality: fields.city,
  administrativeArea: fields.state_region,
  postalCode: fields.postal_code,
});
